module.exports = __webpack_public_path__ + "static/media/331399_07big.00eacd60.jpg";